import dayjs from 'dayjs';

export * from './cookie';
export * from './price';
export * from './domain-utils';

export function matchTimeZoneCode() {
  const regex = /(?:\+|\-)\d{4}/;
  const match = new Date().toString().match(regex);
  return match ? match[0] : null;
}
interface IPostMessage {
  type: string;
  params: any;
}
export const parentPostMessage = (message: IPostMessage, origin: string) => {
  window.parent.postMessage(message, origin);
};

export const getLoginUrlWithRedirect = () => {
  const loc = window.location;
  return (
    '#/login?referrer=' + encodeURIComponent(loc.href.replace(new RegExp('^' + loc.origin), ''))
  );
};

/**
 * 从浏览器获取本地时区偏移量
 * @returns 时区偏移量字符串，例如：+0800 或 -0500
 */
const getBrowserTimezoneOffset = (): string => {
  const now = new Date();
  const offset = now.getTimezoneOffset(); // 获取时区偏移量（分钟）

  // 注意：getTimezoneOffset() 返回的是 UTC 与本地时间的差值，符号相反
  // 如果本地时间比 UTC 快 8 小时，offset 为 -480
  const offsetHours = Math.abs(Math.floor(offset / 60));
  const offsetMinutes = Math.abs(offset % 60);
  const sign = offset <= 0 ? '+' : '-'; // 符号相反

  return `${sign}${offsetHours.toString().padStart(2, '0')}${offsetMinutes
    .toString()
    .padStart(2, '0')}`;
};

/**
 * 将时间转换为指定时区并格式化显示
 * @param date 时间 例如：2025-09-08T07:49:18
 * @param timezone 时区 例如：+0800，为空时从浏览器获取本地时区
 * @returns 转换后的时间字符串，例如：2025-09-08 15:49:18
 */
export const formatTimeByTimezone = (
  date: string,
  timezone?: string,
  format: string = 'YYYY-MM-DD HH:mm:ss',
) => {
  if (!date) {
    console.warn('formatTimeByTimezone', 'date is empty');
    return '';
  }
  try {
    // 如果 timezone 为空，从浏览器获取本地时区
    if (!timezone || timezone.trim() === '') {
      timezone = getBrowserTimezoneOffset();
    }

    // 解析时区偏移量
    const timezoneMatch = timezone.match(/(\+|\-)(\d{2})(\d{2})/);
    if (!timezoneMatch) {
      console.error('formatTimeByTimezone', '无效的时区格式');
      return dayjs(date).format(format);
    }

    const [, sign, hours, minutes] = timezoneMatch;
    const offsetHours = parseInt(hours, 10);
    const offsetMinutes = parseInt(minutes, 10);

    // 计算总偏移分钟数
    const totalOffsetMinutes = (sign === '+' ? 1 : -1) * (offsetHours * 60 + offsetMinutes);

    // 使用 dayjs 进行时区转换
    const convertedTime = dayjs(date)
      // .utc() // 先转换为 UTC 时间
      .add(totalOffsetMinutes, 'minute') // 添加时区偏移
      .format(format); // 格式化为指定格式

    return convertedTime;
  } catch (error) {
    console.error('时区转换失败:', error);
    // 如果转换失败，返回原始时间
    return dayjs(date).format(format);
  }
};
